export namespace CardTypeConstants {
  export const CARD_TYPE_CODE_AMEX = 'AMEX';
  export const CARD_TYPE_CODE_VISA = 'VISA';
  export const CARD_TYPE_CODE_MASTER_CARD = 'MC';
  export const CARD_TYPE_CODE_DISCOVER = 'DISC';
  export const CARD_TYPE_CODE_JCB = 'JCB';
  export const CARD_TYPE_CODE_DINERS_CLUB = 'DINEC';
}
